import root from 'window-or-global';

export default function() {
    /**
     * Enum for URLs for the API endpoints.
     */
    let appContext = '';
    if (root.appContext && root.appContext !== '/') {
        ({appContext} = root);
    }

    if (!root.location.origin) {
        const port = root.location.port ? `:${root.location.port}` : '';
        root.location.origin = `${root.location.protocol}//${root.location.hostname}${port}`;
    }
    const origin = root.apiHost ? root.apiHost : root.location.origin + appContext;

    const URL = {
        //Add URLs for ajax calls here
        ORIGIN: `${origin}`,
        
        SUBSCRIPTION: {
            GET_STATUS: `${origin}/api/get-subcription-status`,
            ADD: `${origin}/api/sign-up-news-letter`,
            OPTOUTLINK: `${origin}/api/get-optoutlink`
        },

        EULA: {
            LATEST: `${origin}/ajax/eula/get/latest`
        }
    };

    return URL;
}
